import { render, staticRenderFns } from "./CreateClaimNew.vue?vue&type=template&id=b475f47e&scoped=true"
import script from "./CreateClaimNew.vue?vue&type=script&lang=ts"
export * from "./CreateClaimNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b475f47e",
  null
  
)

export default component.exports